export const ERROR_TYPES = Object.freeze({
  REGULAR: "REGULAR",
  UNRECOVERABLE: "UNRECOVERABLE",
});

export const ERROR_CONTINUE_STORAGE = "proof:error:continue";
